export default class CorporateMembersBlock {
    constructor(root) {
        this.root = root;
        this.image_blocks = this.root.querySelectorAll('.js-corporate-members-block-images');
        this.active_images = [];
        this.inactive_images = [];

        if(this.numImages() <= 6) {
            return;
        }

        this.determineSet();

        setInterval(() => {
            let to_hide = this.active_images.shift();

            let active_image = this.root.querySelector('img.--active[data-image-id="' + to_hide + '"]');
            let image_block = active_image.parentElement;

            active_image.classList.remove('--active');

            setTimeout(() => {
                let to_show = this.inactive_images.shift();
                let new_image = image_block.querySelector('img[data-image-id="' + to_show + '"]');
                new_image.classList.add('--active');
                this.inactive_images.push(to_hide);
                this.active_images.push(to_show);
            }, 500);
        }, 5000);
    }

    numImages() {
        if(this.image_blocks.length > 0) {
            return this.image_blocks[0].childElementCount;
        }

        return 0;
    }

    determineSet() {
        for(let image_block of this.image_blocks) {
            let images = image_block.children;

            for(let image of images) {
                if(image.classList.contains('--active') && !this.active_images.includes(image.dataset.imageId)) {
                    this.active_images.push(parseInt(image.dataset.imageId));
                }
            }
        }

        for(let i = this.numImages() - 1; i >= 6; i -= 1) {
            this.inactive_images.push(i);
        }

        this.shuffle(this.active_images);
    }

    shuffle(array) {
        for(let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    }
}
